import {remCalc} from '../../_utils'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

export default {
    baseStyle: () => {
        const hidePassword = getAssetUrl('static/img/form/hide-password.svg')
        const showPassword = getAssetUrl('static/img/form/show-password.svg')

        return {
            title: {
                textStyle: {base: 'head-large', lg: 'head-xlarge'},
                fontWeight: 'medium',
                color: 'text.default',
                marginTop: {base: 0, md: remCalc(24)},
                marginBottom: {base: remCalc(16), md: remCalc(24)},
                width: '100%',
            },
            description: {
                textStyle: 'body-medium',
                color: 'text.default',
                fontWeight: 'normal',
                marginBottom: {
                    base: remCalc(16),
                    sm: remCalc(24),
                    md: remCalc(16),
                    lg: remCalc(24),
                },
                width: '100%',
            },
            loginContainer: {
                paddingTop: {base: remCalc(16), md: remCalc(24), lg: remCalc(40), xl: remCalc(80)},
                paddingBottom: {base: remCalc(24), md: remCalc(80)},
                paddingInline: {base: remCalc(16), md: remCalc(24)},
                display: {md: 'flex', xl: 'flex'},
                justifyContent: {md: 'center', xl: 'center'},
            },
            loginFormContainer: {
                display: 'flex',
                flexDirection: {base: 'column', lg: 'row'},
                flexWrap: 'wrap',
                alignContent: 'flex-start',
                width: '100% !important',
                justifyContent: {xl: 'space-between'},
                m: 0,
                p: 0,
            },
            loginStack: {
                width: {base: '100%', lg: '50%', xl: '32%'},
                paddingInline: remCalc(0),
                position: 'relative',
            },
            divider: {
                marginBottom: {base: remCalc(24), lg: remCalc(40)},
            },
            submitButton: {
                w: '100%',
                maxW: {base: '100%', lg: remCalc(332)},
                h: remCalc(40),
            },

            // Label
            '.chakra-form__label': {
                lineHeight: '150%',
                marginTop: remCalc(12),
                marginBottom: '0',
            },

            // Input fields
            'input[type="email"], input[type="text"]': {
                borderColor: 'border.dark !important',
                _hover: {borderColor: 'border.dark !important'},
                _focus: {borderColor: 'border.dark !important', boxShadow: 'none !important'},
                _focusVisible: {
                    borderColor: 'border.dark !important',
                    boxShadow: 'none !important',
                },
            },
            'input[type="password"]': {
                borderColor: 'border.dark !important',
                paddingRight: `${remCalc(40)} !important`,
                _hover: {borderColor: 'border.dark !important'},
                _focus: {borderColor: 'border.dark !important', boxShadow: 'none !important'},
                _focusVisible: {
                    borderColor: 'border.dark !important',
                    boxShadow: 'none !important',
                },
            },
            'input[aria-invalid="true"]': {
                borderColor: 'text.danger !important',
                _hover: {borderColor: 'text.danger !important'},
                _focus: {borderColor: 'text.danger !important'},
                _focusVisible: {borderColor: 'text.danger !important'},
            },
            '.chakra-input__group:has(input[aria-invalid="true"]) .chakra-form__label': {
                color: 'text.danger !important',
            },

            // Floating label
            'input:not(:placeholder-shown) ~ .chakra-form__label': {
                backgroundColor: 'background.default',
                fontSize: `${remCalc(10)} !important`,
                lineHeight: `${remCalc(12)} !important`,
                paddingLeft: `${remCalc(0)} !important`,
                paddingRight: `${remCalc(4)} !important`,
                transform: 'translateY(calc(50% - 26px)) !important',
                transformOrigin: 'left top',
            },
            '.chakra-input__group:focus-within .chakra-form__label': {
                backgroundColor: 'background.default',
                fontSize: `${remCalc(10)} !important`,
                lineHeight: `${remCalc(12)} !important`,
                paddingLeft: `${remCalc(0)} !important`,
                paddingRight: `${remCalc(4)} !important`,
                transform: 'translateY(calc(50% - 26px)) !important',
                transformOrigin: 'left top',
                color: 'border.dark !important',
            },
            'input:not(:placeholder-shown) ~ .chakra-form__label::before, .chakra-input__group:focus-within .chakra-form__label::before':
                {
                    display: 'none !important',
                },

            // Error message
            '[role="alert"]': {
                color: 'text.danger',
                textStyle: 'body-xxsmall',
                mt: 'xxsmall.md',
                textAlign: 'left',
            },
            '.chakra-input__group:has(input[type="password"]) .chakra-input__right-element .chakra-button':
                {
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    right: remCalc(16),
                    background: 'transparent',
                    padding: 0,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: remCalc(16),
                    borderRadius: remCalc(4.5),
                    _focus: {
                        boxShadow: `0 0 0 ${remCalc(2)} #87b9ea !important`,
                        border: '1px solid #87b9ea !important',
                    },
                    _focusVisible: {
                        boxShadow: `"'none !important'"`,
                    },
                },
            '.chakra-input__group:has(input[type="password"]) .chakra-input__right-element .chakra-button svg':
                {
                    color: 'transparent',
                    background: `transparent url("${hidePassword}") no-repeat center / ${remCalc(
                        24,
                    )} ${remCalc(24)} !important`,
                    height: remCalc(24),
                    width: remCalc(24),
                    right: remCalc(16),
                },
            '.chakra-input__group:has(input[type="text"]) .chakra-input__right-element .chakra-button':
                {
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    right: remCalc(16),
                    background: 'transparent',
                    padding: 0,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: remCalc(16),
                    borderRadius: remCalc(4.5),
                    outline: 'none',
                    _focus: {
                        boxShadow: `0 0 0 ${remCalc(2)} #87b9ea !important`,
                        border: '1px solid #87b9ea !important',
                    },
                    _focusVisible: {
                        boxShadow: `"'none !important'"`,
                    },
                },
            '.chakra-input__group:has(input[type="text"]) .chakra-input__right-element .chakra-button svg':
                {
                    color: 'transparent',
                    background: `transparent url("${showPassword}") no-repeat center / ${remCalc(
                        24,
                    )} ${remCalc(24)} !important`,
                    height: remCalc(24),
                    width: remCalc(24),
                    right: remCalc(16),
                },
        }
    },
}
